import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Ho4ArticleSidebar from '../components/Ho4ArticleSidebar';
import { HO4_LAST_MODIFIED } from '../data/ho4Articles';

function Ho4SwitchCompaniesArticlePage() {
  const navigate = useNavigate();
  const articleLinkStyle = { color: '#065F46', fontWeight: 600, textDecoration: 'underline' };

  useEffect(() => {
    const previousTitle = document.title;
    const descriptionMeta = document.querySelector('meta[name="description"]');
    const previousDescription = descriptionMeta?.getAttribute('content') ?? '';
    document.title = 'How to Switch HO-4 Insurance Companies | GetSkimp';
    if (descriptionMeta) {
      descriptionMeta.setAttribute(
        'content',
        'Learn how to switch HO-4 renters insurance companies smoothly without coverage gaps.'
      );
    }
    return () => {
      document.title = previousTitle;
      if (descriptionMeta) descriptionMeta.setAttribute('content', previousDescription);
    };
  }, []);

  return (
    <div className="container">
      <div style={{ display: 'grid', gridTemplateColumns: '260px 1fr', gap: '2rem' }}>
        <Ho4ArticleSidebar
          activeHref="/knowledge-base/how-to-switch-ho4-insurance-companies"
          onNavigate={(href) => navigate(href)}
        />
        <section>
          <div style={{ marginBottom: '1rem' }}>
            <button type="button" className="btn btn-sm btn-outline" onClick={() => navigate('/knowledge-base')} style={{ marginBottom: '1rem' }}>
              Back to self help library
            </button>
            <h2 style={{ marginBottom: '0.5rem' }}>How to switch HO-4 insurance companies</h2>
            <p style={{ marginBottom: 0, color: '#4B5563' }}>Switching is straightforward when you avoid coverage gaps and timing mistakes.</p>
            <p style={{ marginTop: '0.5rem', fontSize: '0.85rem', color: '#6B7280' }}>Last modified: {HO4_LAST_MODIFIED}</p>
          </div>

          <article className="card mb-4">
            <div className="card-body">
              <h3 style={{ marginBottom: '0.75rem' }}>Quick answer</h3>
              <p>
                The safest way to switch HO-4 providers is to start the new policy first, confirm documents, then
                cancel the old policy after the new one is active.
              </p>
              <h3 style={{ marginBottom: '0.75rem', marginTop: '1.5rem' }}>Switch checklist</h3>
              <ol style={{ paddingLeft: '1.2rem', marginBottom: 0 }}>
                <li style={{ marginBottom: '0.5rem' }}>Compare quote options and coverage terms.</li>
                <li style={{ marginBottom: '0.5rem' }}>Match liability limits and deductible to your current needs.</li>
                <li style={{ marginBottom: '0.5rem' }}>Set new policy effective date before canceling old policy.</li>
                <li>Send updated proof of insurance to your landlord/property manager.</li>
              </ol>
              <p style={{ marginTop: '1rem', marginBottom: 0 }}>
                Use{' '}
                <Link to="/knowledge-base/how-much-liability-do-i-need-for-renters-insurance" style={articleLinkStyle}>
                  liability guidance
                </Link>{' '}
                and{' '}
                <Link to="/knowledge-base/what-deductible-should-i-choose-for-ho4" style={articleLinkStyle}>
                  deductible guidance
                </Link>{' '}
                before switching.
              </p>
            </div>
          </article>

          <section className="card mb-4" style={{ borderColor: 'var(--color-green)', background: 'linear-gradient(135deg, #ECFDF5 0%, #FFFFFF 100%)', boxShadow: 'var(--shadow-md)' }}>
            <div className="card-body">
              <h3 style={{ marginBottom: '0.5rem', color: '#065F46' }}>Start renters insurance with GetSkimp</h3>
              <p style={{ marginBottom: '1rem' }}>Compare updated HO-4 options and switch with confidence.</p>
              <button type="button" className="btn btn-primary" onClick={() => navigate('/qualify')} style={{ fontWeight: 700, paddingInline: '1.4rem' }}>Get started now</button>
            </div>
          </section>
          <section className="card" style={{ borderColor: '#FBBF24', background: 'linear-gradient(135deg, #FFFBEB 0%, #FFFFFF 100%)' }}>
            <div className="card-body">
              <h3 style={{ marginBottom: '0.5rem', color: '#92400E' }}>Need help avoiding a coverage gap?</h3>
              <p style={{ marginBottom: '1rem' }}>An agent can help line up your effective dates and documents correctly.</p>
              <button type="button" className="btn btn-outline" onClick={() => navigate('/help')} style={{ borderColor: '#D97706', color: '#92400E', fontWeight: 700 }}>Speak to an agent</button>
            </div>
          </section>
        </section>
      </div>
    </div>
  );
}

export default Ho4SwitchCompaniesArticlePage;

